import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { List, AutoSizer } from 'react-virtualized';
import Icon from '../Icon';
import PlayerItem from './PlayerItem';
import { useDebounce } from './useDebounce';
import { fetchSuggestions } from './utils';
import './styles.less';


const PlayerSearch = ({ rounded, size, teamIcons }) => {
    const [query, setQuery] = useState('');
    const [currentResult, setCurrentResult] = useState(-1);
    const [results, setResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const debouncedQuery = useDebounce(query, 200);
    const node = useRef();

    useEffect(() => {
        document.addEventListener('click', handleClick);

        return () => document.removeEventListener('click', handleClick);
    }, [])

    useEffect(() => {
        if (debouncedQuery) {
           fetchSuggestions(debouncedQuery).then(results => setResults(results))
        } else {
            setResults([]);
        }
    }, [debouncedQuery]);

    useEffect(() => {
        if (results.length > 0) {
            setShowResults(true);
        } else {
            setShowResults(false);
        }
        setCurrentResult(-1);
    }, [results]);

    const handleClick = (e) => {
       if(!node.current.contains(e.target)) {
           setShowResults(false);
       }
    };

    const handleKeyDown =({ keyCode }) => {
        const down = keyCode === 40;
        const up = keyCode === 38;
        const enter = keyCode === 13;
        const esc = keyCode === 27;
        if (down && currentResult < results.length - 1) {
            setCurrentResult(currentResult + 1);
        }

        if (up && currentResult > -1) {
            setCurrentResult(currentResult - 1);
        }

        if (enter && currentResult > -1) {
            window.location = results[currentResult].url;
        }

        if (esc) {
            setShowResults(false);
        }
    };


    const rowRenderer = ({ index, style }) => {
        return (
                    <PlayerItem
                        player={results[index]}
                        style={style}
                        key={results[index].id}
                        active={index === currentResult}
                        rounded={rounded}
                        showIcons={teamIcons}
                    />);
    };

    return (
        <div className="p-player-search" ref={node}>
            <div className="p-player-search__form">
                <input className={`p-player-search__input p-player-search__input--${size}`}
                    type="search" 
                    onChange={e => setQuery(e.target.value)}
                    placeholder="Player Search..."
                    onKeyDown={handleKeyDown}
                    value={query}
                />
                {query === '' && 
                    <Icon
                        className={`p-player-search__input--icon p-player-search__input--icon--${size}`}
                        icon="search"
                    />}
            </div>
            {showResults > 0 &&
                <AutoSizer>
                {({ height, width }) =>
                    <List
                        className={`p-player-search__list p-player-search__list--${size}`}
                        height={results.length < 5 ? (results.length * 50) : 250}
                        rowCount={results.length}
                        rowHeight={50}
                        overscanRowCount={4}
                        rowRenderer={rowRenderer}
                        width={width}
                        scrollToIndex={currentResult}
                    />
                }
            </AutoSizer>
            }
         </div>
    );
}

PlayerSearch.propTypes = {
    rounded: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md']),
    teamIcons: PropTypes.bool
}

PlayerSearch.defaultProps = {
    rounded: true,
    size: 'md',
    teamIcons: true
}

export default PlayerSearch
